module.exports = __webpack_public_path__ + "img/guigeliao4.a6c59139.jpg";